import script from "./InvoiceDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceDialog.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceDialog.vue?vue&type=style&index=0&id=0fe4ef2d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fe4ef2d"]])

export default __exports__